import React from 'react';

const Contact = () => {
  return (
    <div>
      <h2>Contact Us</h2>
      <p>For inquiries, please reach us at contact@realestate.com</p>
    </div>
  );
};

export default Contact;
